export default function Configure($stateProvider) {
	$stateProvider.state('rapports-activites', {
		parent: 'gestion',
		url: '/rapports-activites',
		views: {
			gestion: {
				template: '<ui-view></ui-view>'
			}
		},
		ncyBreadcrumb: {
			label: '{{ "LAYOUT.NAVIGATION.STOCKS" | translate }}'
		}
	});

	$stateProvider.state('rapports-activites.list', {
		url: '/list',
		template: '<rapports-activites></rapports-activites>',
		rights: { domain: 'stockconfiggra', right: 'read' },
		ncyBreadcrumb: {
			label: '{{ "STOCKS.BREADCRUMBS.GESTION_RAPPORTS_ACTIVITES" | translate}}'
		},
		navigation: {
			menu: 'stocks_configuration',
			translate: 'STOCKS.BREADCRUMBS.GESTION_RAPPORTS_ACTIVITES',
			order: 3
		},
		search: 'STOCKS.BREADCRUMBS.GESTION_RAPPORTS_ACTIVITES'
	});

	$stateProvider.state('rapports-activites.rapports-organisation-produits', {
		url: '/rapports-organisation-produits/{idRapport}/{rapportLabel}',
		template: '<rapports-organisation-produits></rapports-organisation-produits>',
		rights: { domain: 'stockconfig', right: 'read' },
		ncyBreadcrumb: {
			label: '{{ "STOCKS.BREADCRUMBS.RAPPORTS_ORGANISATION_PRODUITS" | translate}}'
		},
		search: 'STOCKS.BREADCRUMBS.RAPPORTS_ORGANISATION_PRODUITS'
	});
}

Configure.$inject = ['$stateProvider'];
